module.exports = __webpack_public_path__ + "media/images/mobile/Mask Group 6-5981ef2e4d100b3c34c4c48b5e0b3508.png";